export const requestsPropertyComposer = (search: string): boolean =>
  new URLSearchParams(search).get('add') === '1';

export const withoutPropertyComposerRequest = (search: string): string => {
  const params = new URLSearchParams(search);
  params.delete('add');
  const next = params.toString();
  return next ? `?${next}` : '';
};
